import base64 from 'base-64'

window.ecuadStore = window.ecuadStore || { searchindex: null, sectionindex: null, posts: {} }

class Store {
  static getSearchIndex(baseURL, path) {
  	if (window.ecuadStore[baseURL]) {
  		return Promise.resolve(window.ecuadStore[baseURL])
  	}
  	else {
      const base = process.env.NODE_ENV === 'development' ? 'http://ecuad.localhost' : 'https://d1bdilxpumkn65.cloudfront.net' 
  		return fetchData(`${base}/${baseURL}/${path}?20220216`).then((res) => {
	      if (res) {
          if (baseURL === 'sectionindex') {
            res.data.forEach(entry => {
              if (typeof entry.children !== "undefined") {
                res.data.push(...entry.children)
                delete entry.children
              }
            })
          }
	        window.ecuadStore[baseURL] = res
	      }
	      return res
	    })
	  }
  }
}

export default Store

function fetchData(url) {
	let headers = new Headers()
  // if (window.location.hostname !== 'localhost') {
  //   headers.append('Authorization', 'Basic ' + base64.encode("ecu:"))
  // }
  headers.append('Access-Control-Allow-Headers', 'Content-Type')
  headers.append('Content-Type', 'application/json')

  return fetch(url, { headers: headers, mode: 'cors' })
    .then(res => res.json())
    .then(res => {
      return res
    })
}
